import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { UpdateDesignTagsDocument } from './update.generated';

export const useUpdateDesignTags = (options: ApiOptions<typeof UpdateDesignTagsDocument> = {}) => {
  const { t } = useTranslation();
  return useMutation(UpdateDesignTagsDocument, {
    ...useNotifications(UpdateDesignTagsDocument, {
      failure: t('api.design_tags.update_error'),
      success: t('api.design_tags.update_success'),
    }),
    ...options,
  });
};
